/**
 * Block 12 calculator formulas — per-anketa types, derived from
 * `CalculatorParams` discriminated union в `contracts/calculator.ts`.
 *
 * Эти aliases локальные для formula-layer — Zod-схемы остаются source of
 * truth в `contracts/`. `Extract<>` сохраняет точную типизацию полей и
 * narrowing через discriminator `type`.
 *
 * Reference: `docs/methodology/calculator-formulas.md` Часть 2.
 */

import type { CalculatorParams } from '../../contracts/calculator';

export type KitchenParams = Extract<CalculatorParams, { type: 'kitchen' }>;
export type CabinetParams = Extract<CalculatorParams, { type: 'cabinet' }>;
export type BathTabletopParams = Extract<CalculatorParams, { type: 'bath-tabletop' }>;
export type BathShelfAboveParams = Extract<CalculatorParams, { type: 'bath-shelf-above' }>;
export type BathCabinetParams = Extract<CalculatorParams, { type: 'bath-cabinet' }>;
export type TvZoneParams = Extract<CalculatorParams, { type: 'tv-zone' }>;
export type BalconyParams = Extract<CalculatorParams, { type: 'balcony' }>;
export type OtherParams = Extract<CalculatorParams, { type: 'other' }>;

/**
 * Утилита для defensive runtime-guard: проверяет что обязательная dimension
 * (length, height, и т.п.) — конечное положительное число. Phase B2 формулы
 * принимают Zod-validated input, но `BaseDimensionsSchema.height` остаётся
 * `.optional()` — поэтому формулы обязаны проверять перед использованием.
 *
 * Phase B3 refinement в анкетах (Кухня H ≥ 600, и пр.) уберёт необходимость
 * runtime guards в hot paths, но fail-fast на B2 ловит integration bugs.
 */
export function assertPositiveDimension(
  value: number | undefined,
  label: string,
): asserts value is number {
  if (typeof value !== 'number' || !Number.isFinite(value) || value <= 0) {
    throw new Error(`${label}: expected positive finite number, got ${value}`);
  }
}
